import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Add from "../../../../icons/add.svg";
import Delete from "../../../../icons/delete.svg";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
// import ExportarListaTecnicos from "./ExportarListaTecnicos";
import { UsuarioContext } from "../../../../providers/userContext";
import BreadCrumb from "../../../../components/navbar/Breadcrumb";
import { Box, Tooltip } from "@mui/material";
import { DataTable } from "../../../../components";
import { useLocation, useNavigate } from 'react-router-dom';
import { construirURLParamsFiltros, useRecogerURLParamsFiltros } from "../../../../functions/parametrosURL/funcionesParamsURL";
import { withRouter } from "../../../../providers/withRouter";
import { deleteAlmacen, getAlmacenes } from "../../../../services";
import Warning from "../../../../icons/warning.svg";

const Almacenes = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const {filtroOrder} = useRecogerURLParamsFiltros();
  const user = useContext(UsuarioContext)
  const [almacenes, setAlmacenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(true);
  const [data, setData] = useState({
    meta: {},
    data: [],
  });

  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {

      fetchData();
      localStorage.setItem("hasReloaded", "false"); 
    }
  }, [location]);
  

  const fetchData = async ({ offset, limit, filtros = {}, order,orderBy, } = {}) => {
    
    
    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order =   order || filtroOrder.orden || 'ASC';

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros,  order,orderBy,);
    
    const payload = {
      filtros,
      params: { page: offset, limit,  order,orderBy, },
    };
    try {
      setLoading(true);
      const response = await getAlmacenes(payload);
      const { meta, data } = response;
      console.log(data)
      setAlmacenes(data)
      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const formatData = (data) => {
    return data.map((row, i) => ({
      id: row.id,
      nombre: row.nombre,
      direccion: row.direccion,
      municipio: row.municipio,
      provincia: row.provincia,
      telefono: row.telefono,
      stockBajo: row.stockBajo,
    }));
  };
  const almacenesRows = [

    {
      id: "nombre",
      numeric: false,
      disablePadding: false,
      label: t('almacenes.columns.almacen'),
      overrideFunc: (data, row) => (
        <Link to={`/almacenes/${row.id}`}>
          {row.nombre}
        </Link>
      ),
    },
    {
      id: "direccion",
      numeric: false,
      disablePadding: false,
      label: t('almacenes.columns.address'),
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('almacenes.columns.municipality'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('almacenes.columns.province'),
    },
    {
      id: "telefono",
      numeric: false,
      disablePadding: false,
      label: t('almacenes.columns.phone'),
    },
    {
      id: "stockBajo",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data, row) => (
        <div style={{ display: 'flex' }}>
          {data ?
            <Tooltip title={t('almacenes.tooltips.stockBajo')} arrow>
                <img src={Warning} style={{ margin:2}} width={15} alt="stock bajo" />
            </Tooltip>
          : null}
        </div>
      ),
    },
    user.rol === 'ADMIN' ?
    {
      id: "eliminar",
      numeric: false,
      disablePadding: false,
      label: t('almacenes.columns.delete'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <img
          src={Delete}
          alt={t('actions.delete')}
          className="tableIcon"
          onClick={() => eliminarAlmacen(row)}
        ></img>
      )
    }
    :
    {

      noObjeto:true

    },
  ]

  const eliminarAlmacen = (com) => {
    Swal.fire({
      title: t('almacenes.messages.confirmDelete'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: t('actions.cancel'),
      confirmButtonText: t('messages.yesDelete'),
    })
      .then((result) => {
        if (result.isConfirmed) {

          deleteAlmacen(com.id)
            .then((res) => {

              if (res.message === "ALMACEN_DELETED") {
                toast.success(t('almacenes.messages.deleted'));
                setRecargar(!recargar);
              } else {
                toast.error(t('almacenes.messages.deleteError'));
              }
            })
            .catch((e) => {
              toast.error(t('almacenes.messages.deleteError'));
              console.log(e);
            });
        }
      })
      .catch((e) => {
        toast.error(t('messages.error'));
        console.log(e);
      });
  };

  return (
    <>
      <BreadCrumb rutas={[{path:`/almacenes`, label: t('almacenes.title')}]} />
      <div className="listPage">
        <div className="gridCard">
            <div className="gridHead">
                {t('almacenes.title').toUpperCase()}
            </div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        <div className="contentBar">
          <div style={{ display: 'flex'}}>
            {/* {show ? (
              <ExportarListaTecnicos tecnicos={tecnicos} />
            ) : (
              <button className="bigBtn" onClick={() => setShow(true)}>
                <img src={Excel} alt={t('installers.generateList')} width="30px" /> {t('installers.generateList')}
              </button>
            )} */}
          </div>
          {(user.rol === "ADMIN" || user.rol === "VENT") &&
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'end'}}>
              <Link to="/almacenes/nuevo">
                <div className="contentButton mx-2">
                  <img src={Add} alt={t('almacenes.messages.new')} />
                </div>
              </Link>
            </div>
          }
        </div>
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={almacenesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                // filtros={busqueda}
                mensaje={t('almacenes.messages.noAlmacenes')}
                recargar={recargar}
              />
            </Box>
          </Box>
        </div>

      </div>
    </>
  );
};

export default withRouter(Almacenes);
